export default __webpack_public_path__ + "static/media/service02.eab65b28.png";